import React, { useEffect } from "react";
import OtpInput from "react-otp-input";
import {
  AuthorizationMutationVariables,
  useAuthorizationMutation,
} from "src/generated/graphql";
import { Controller, useForm } from "react-hook-form";
import { setCookie } from "nookies";
import { useRouter } from "next/router";

interface IAuthorizationFormProps {
  phone: string;
  setFormSequence: React.Dispatch<
    React.SetStateAction<"phoneNumber" | "phoneCode">
  >;
}

const AuthorizationForm: React.FC<IAuthorizationFormProps> = ({ phone }) => {
  const router = useRouter();

  const [authorization] = useAuthorizationMutation();
  const {
    register,
    handleSubmit,
    errors,
    setError,
    control,
    watch,
  } = useForm<AuthorizationMutationVariables>({
    defaultValues: {
      phoneNumber: phone,
      phoneCode: "",
    },
  });

  const watchField = watch("phoneCode");

  const onSubmit = handleSubmit(async (variables) => {
    const {
      data: {
        authorization: { jwt, pilot, errors },
      },
    } = await authorization({ variables });

    if (jwt) {
      setCookie(null, process.env.COOKIE, jwt, {
        maxAge: 60 * 60 * 24 * 30 * 365,
        path: "/",
      });

      if (pilot.signInCount > 1) {
        router.push("/pilot/dashboard");
      } else {
        router.push("/pilot/profile/update");
      }
    } else if (errors) {
      errors.forEach((error) => {
        setError(error.path as any, { type: "manual", message: error.detail });
      });
    }
  });

  useEffect(() => {
    if (watchField.length === 4) {
      onSubmit();
    }
  }, [watchField]);

  return (
    <form onSubmit={onSubmit}>
      <h1 className="text-3xl mb-1">Verification Code</h1>
      <p className="text-sm text-gray-400 mb-8">
        Code has been sent to {phone}
      </p>

      <input
        type="hidden"
        name="phoneNumber"
        ref={register({
          required: "Required",
        })}
      />
      <Controller
        name="phoneCode"
        control={control}
        as={
          <OtpInput
            numInputs={4}
            isInputNum
            shouldAutoFocus
            containerStyle="text-4xl justify-between max-w-xs mx-auto mb-6"
            inputStyle="border border-gray-500 rounded mx-2 caret-none focus:border-blue w-12"
            focusStyle="outline-none border-blue-500 shadow-outline"
          />
        }
      />

      {Object.values(errors).map((error, index) => (
        <p key={index} className="text-red-500 mb-6">
          {error.message}
        </p>
      ))}
    </form>
  );
};

export default AuthorizationForm;
